// Phase overlays: attract, wave intro, wave-end bonus, and the "THE END" screen.

import type { GameState } from '../core';
import { FIELD_W, FIELD_H } from '../core';
import { PALETTE } from './palette';

type Ctx = CanvasRenderingContext2D;

function center(
  ctx: Ctx,
  title: string,
  subtitle: string | null,
  color: string,
): void {
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillStyle = color;
  ctx.font = '700 64px ui-monospace, monospace';
  ctx.fillText(title, FIELD_W / 2, FIELD_H / 2 - 20);
  if (subtitle !== null) {
    ctx.font = '500 22px ui-monospace, monospace';
    ctx.fillStyle = PALETTE.hudDim;
    ctx.fillText(subtitle, FIELD_W / 2, FIELD_H / 2 + 40);
  }
}

export function drawScreens(ctx: Ctx, state: GameState): void {
  const p = state.phase;
  switch (p.kind) {
    case 'attract':
      center(ctx, 'MISSILE COMMAND', 'CLICK OR PRESS SPACE TO DEFEND', PALETTE.hud);
      break;
    case 'waveIntro':
      center(ctx, `WAVE ${p.wave}`, null, PALETTE.hud);
      break;
    case 'waveEnd':
      center(ctx, 'BONUS', `${p.bonus.points}`, PALETTE.ammo);
      break;
    case 'gameOver':
      center(ctx, 'THE END', null, PALETTE.enemy);
      break;
    case 'playing':
      break;
  }
}
